<template>
  <div
    class="header"
    :class="{
      header__blue: theme == 'blue',
      header__white: theme == 'white',
      header__left: left == true,
      header__arrow: arrow == true,
    }"
  >
    <p class="header__text">{{ title }}</p>
  </div>
</template>

<script>
// import "./Header.scss";

export default {
  name: "Header",
  props: {
    title: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: "blue",
    },
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    arrow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Header.scss'

</style>